import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { getSubChannels } from 'utils/common';
import { navigationSelector } from 'common/selectors/navigation';
import { DropDown, DropDownItem, DropDownMenu } from 'components/dropdown-nav';

export const NavItem = ({ vertical = true, navItem, isMenuShown, onClosing, onOpen, ariaRole }) => {
  const { url, title, active, parentId, id } = navItem;
  const navigation = useSelector(navigationSelector);

  const isHomePage = parentId === null; // parentId is null for root channels
  const activeClassName = active ? 'link active' : 'link';
  const subChannels = !isHomePage ? getSubChannels(navigation, navItem) : [];
  const hasSubChannels = subChannels.length > 0 && !isHomePage;

  return (
    <DropDown
      hasCaret={hasSubChannels}
      onClosing={onClosing}
      onOpen={onOpen}
      isMenuShown={isMenuShown}
      vertical={vertical}
      elementId={id}
      isActive={active}
      title={title}
      ariaControls={`ct-navigation-item-${id}`}
      ariaRole={ariaRole}
    >
      <Link id={`ct-navigation-item-${id}`} className={activeClassName} to={url} data-e2e={`nav-item-${id}`}>
        {title}
      </Link>

      {hasSubChannels && (
        <DropDownMenu>
          {subChannels.map((subChannel, index) => {
            if (getSubChannels(navigation, subChannel).length === 0) {
              return (
                <DropDownItem
                  key={index}
                  className={subChannel.active ? `active level` : 'level'}
                  elementId={subChannel.id}
                >
                  <Link to={`${subChannel.url}`}>{subChannel.title}</Link>
                </DropDownItem>
              );
            } else {
              return (
                <DropDownItem
                  key={index}
                  className={subChannel.active ? 'active level' : 'level'}
                  elementId={subChannel.id}
                >
                  <NavItemH navItem={subChannel} navigation={navigation} isMenuShown={isMenuShown} />
                </DropDownItem>
              );
            }
          })}
        </DropDownMenu>
      )}
    </DropDown>
  );
};

export const NavItemH = ({ navItem }) => {
  const navigation = useSelector(navigationSelector);
  const [isMenuShown, setIsMenuShown] = useState(false);

  return (
    <div role="list" className="ct-navItemH">
      <NavItem
        ariaRole={'listitem'}
        navItem={navItem}
        navigation={navigation}
        vertical={false}
        isMenuShown={isMenuShown}
        onClosing={() => setIsMenuShown(false)}
        onOpen={() => setIsMenuShown(true)}
      />
    </div>
  );
};

export const MoreNavItemComponent = ({ activeClass = '', children }) => {
  const NAVIGATION_MORE_BUTTON_ID = -2;
  const { t } = useTranslation();

  return (
    <DropDown
      ariaRole="listitem"
      title={t('more')}
      hasCaret={true}
      elementId={NAVIGATION_MORE_BUTTON_ID}
      isActive={!!activeClass}
    >
      <button type="button" className={`link link-button ${activeClass}`}>
        {t('more')}
      </button>
      {children && <DropDownMenu>{children}</DropDownMenu>}
    </DropDown>
  );
};
